/**
 * Firestore collection names
 */
export enum Collections {
  Achievements = 'achievements',
  Activities = 'activities',
  Badges = 'badges',
  ConnectedAccounts = 'connectedAccounts',
  GameActions = 'gameActions',
  Installations = 'installations',
  Notifications = 'notifications',
  Projects = 'projects',
  RepoProjectMap = 'repoProjectMap',
  Rewards = 'rewards',
  Settings = 'settings',
  Stats = 'stats',
  UnmatchedEvents = 'unmatchedEvents',
  Users = 'users',
}
